import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectMeterDefaults, selectMeterCompartmentDefaults, updateDefaults } from '../../../../redux/panelDetailSlice';

export default function MeterGridSection() {
  const dispatch = useDispatch();
  const meter = useSelector(selectMeterDefaults);
  const meterComp = useSelector(selectMeterCompartmentDefaults);

  const handleMeterChange = (phaseKey, field, value) => {
    const numVal = parseInt(value, 10);
    if (isNaN(numVal) || numVal < 1) return;
    dispatch(updateDefaults({
      section: 'meter',
      changes: { [phaseKey]: { [field]: numVal } },
    }));
  };

  const handleCompChange = (field, value) => {
    dispatch(updateDefaults({
      section: 'meterCompartment',
      changes: { [field]: value },
    }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-two-col">
        <div className="detail-col">
          <div className="detail-col-title">3 Faz Grid</div>
          <div className="detail-field">
            <label>Maks. Satir</label>
            <input
              type="number"
              min="1"
              max="10"
              value={meter.phase3.maxRows}
              onChange={e => handleMeterChange('phase3', 'maxRows', e.target.value)}
            />
          </div>
        </div>
        <div className="detail-col">
          <div className="detail-col-title">1 Faz Grid</div>
          <div className="detail-field">
            <label>Maks. Satir</label>
            <input
              type="number"
              min="1"
              max="10"
              value={meter.phase1.maxRows}
              onChange={e => handleMeterChange('phase1', 'maxRows', e.target.value)}
            />
          </div>
        </div>
      </div>

      <hr className="detail-hr" />

      <div className="detail-field">
        <label>Yerlesim Modu</label>
        <select
          value={meterComp.placementMode || 'row'}
          onChange={e => handleCompChange('placementMode', e.target.value)}
        >
          <option value="row">Satir</option>
          <option value="column">Sutun</option>
        </select>
      </div>

      <div className="detail-field">
        <label>Tek Fazlari Kaydir</label>
        <input
          type="checkbox"
          checked={!!meterComp.shiftSinglePhase}
          onChange={e => handleCompChange('shiftSinglePhase', e.target.checked)}
        />
      </div>

      <div className="detail-field">
        <label>Maks. Yukseklik (cm)</label>
        <input
          type="number"
          min="50"
          max="300"
          value={meterComp.maxHeight || 150}
          onChange={e => handleCompChange('maxHeight', parseInt(e.target.value, 10) || 150)}
        />
      </div>

      <div className="detail-field">
        <label>Maks. Kapak Genisligi (cm)</label>
        <input
          type="number"
          min="20"
          max="120"
          value={meterComp.maxDoorWidth || 60}
          onChange={e => handleCompChange('maxDoorWidth', parseInt(e.target.value, 10) || 60)}
        />
      </div>
    </div>
  );
}
